





import { Component, Vue } from 'vue-property-decorator';
import menuModule from '@/store/modules/common/menu.module';

@Component({
  name: 'v-menu-button'
})
export default class VMenuButton extends Vue {
  public updateMenuStatus() {
    menuModule.updateMenuStatus(!menuModule.isShowMenu);
  }
}
